<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pneHWk/tc-custom/9780547526713.jpg?1736422874684" alt="This image is the cover for the book 3 Nights in August"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">3 Nights in August
      </h1>
      <p class="bookDescription body article font2">
        <b>This inside view with the Cardinals’ Tony La Russa </b><b>by the #1 <i>New York Times</i>–bestselling author of <i>Friday Night Lights</i> “should appeal to any baseball fan” (<i>Publishers Weekly</i>).</b><br/><br/> A Chicago Tribune Best Book of the Year<br/>  <br/>  “Plenty of books have taken us inside baseball, but <i>August</i> takes us directly inside players’ heads.” —<i>Entertainment Weekly</i><br/>  <br/><i>3 Nights in August</i> captures the strategic and emotional complexities of baseball’s quintessential form: the three-game series. As the St. Louis Cardinals battle their archrival, the Chicago Cubs, we watch from the dugout through the eyes of legendary Tony La Russa, considered by many to be the greatest manager of the modern era. In his thirty-three years of managing, La Russa won three World Series titles and was named Manager of the Year a record five times. He now stands as the third-winningest manager in the history of baseball.<br/>  <br/> A great leader, La Russa built his success on the conviction that ball games are won not only by the numbers but also by the hearts and minds of those who play. Drawing on unprecedented access to a major league skipper and his team, Buzz Bissinger portrays baseball with a revelatory intimacy that offers many surprisingly tactical insights—and furthers the debate on major league managerial style and strategy in his provocative afterword.<br/>  <br/> “Superb . . . Will be devoured by hard-core strategists.” —<i>The New York Times Book Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Buzz Bissinger
      </h2>
      
      <p class="authorDescription body article">Buzz Bissinger is a Pulitzer Prize&ndash;winning journalist and author of four books, including <I>New York Times</I> bestseller <I>3 Nights in August </I>and <I>Friday Night Lights</I>, which has sold two million copies and inspired a film and TV franchise. He is a contributing editor for <I>Vanity Fair</I> and a sports columnist for the <I>Daily Beast</I>. Bissinger has written for the <I>New York Times</I>, the <I>New Republic</I>, <I>Time</I>, and many other publications.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b022565